import axios from 'axios';

const PaymentService = {
  getAll() {
    return axios.get('paymentMethod').catch((error) => {
      throw new Error(`PaymentService.getAll ${error}`);
    });
  },
  get(id) {
    return axios.get(`paymentMethod/${id}`).catch((error) => {
      throw new Error(`PaymentService.get ${error}`);
    });
  },
};

export default PaymentService;
